<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="статус отклика"
      :is-disabled="isDisabled"
      :state="state"
      :initial-value="value"
      :get-item-by-id="getRecruitResponseStatus"
      :get-list="getItems"
      :can-create-catalog="canEditRecruitResponseStatus()"
      :drop-up="dropUp"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <recruit-response-status
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import CatalogSelect from "../CatalogSelect.vue";
    import RecruitResponseStatus from "./RecruitResponseStatus.vue";

export default {
  name: "RecruitResponseStatusSelect",
  components: { RecruitResponseStatus, CatalogSelect },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    state: { type: Boolean, default: null },
    dropUp: { type: Boolean, default: false },
    value: { type: Number, default: null },
    excludeIds: { type: Array, default: () => [] }
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getRecruitResponseStatusesSearch('');
      let items = (result && result.data) ? result.data : [];

      if (this.excludeIds && this.excludeIds.length) {
        items = items.filter(item => !this.excludeIds.includes(item.id));
      }

      return items;
    },
    async getRecruitResponseStatus(id) {
      const result = await this.getRecruitResponseStatusById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditRecruitResponseStatus() {
      return this.hasPermission([PERM.CATALOG_RECRUIT_RESPONSE_STATUS_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/RecruitResponseStatuses/RecruitResponseStatusSelect.vue